'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { useLocale, useTranslations } from 'next-intl';
import { Share2, Link as LinkIcon, Check } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
type PropsType = {
  url: string;
  title: string;
  variant?: 'default' | 'secondary' | 'ghost' | 'outline';
  size?: 'default' | 'sm' | 'lg' | 'icon';
  className?: string;
};
const ShareButton = t0 => {
  const $ = _c(72);
  const {
    url,
    title,
    variant: t1,
    size: t2,
    className: t3
  } = t0;
  const variant = t1 === undefined ? "secondary" : t1;
  const size = t2 === undefined ? "sm" : t2;
  const className = t3 === undefined ? "" : t3;
  const t = useTranslations();
  const locale = useLocale();
  const [copied, setCopied] = useState(false);
  const normalizedPath = url.startsWith("/") ? url : `/${url}`;
  let t4;
  if ($[0] !== locale || $[1] !== normalizedPath) {
    t4 = normalizedPath.startsWith(`/${locale}/`) ? normalizedPath : `/${locale}${normalizedPath}`;
    $[0] = locale;
    $[1] = normalizedPath;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const localizedPath = t4;
  const fullUrl = typeof window !== "undefined" ? `${window.location.origin}${localizedPath}${window.location.search}` : localizedPath;
  const t5 = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(fullUrl)}`;
  const t6 = `https://twitter.com/intent/tweet?url=${encodeURIComponent(fullUrl)}&text=${encodeURIComponent(title)}`;
  const t7 = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(fullUrl)}`;
  const t8 = `https://wa.me/?text=${encodeURIComponent(`${title} - ${fullUrl}`)}`;
  const t9 = `https://t.me/share/url?url=${encodeURIComponent(fullUrl)}&text=${encodeURIComponent(title)}`;
  let t10;
  if ($[3] !== t5 || $[4] !== t6 || $[5] !== t7 || $[6] !== t8 || $[7] !== t9) {
    const shareLinks = {
      facebook: t5,
      x: t6,
      linkedin: t7,
      whatsapp: t8,
      telegram: t9
    };
    t10 = platform => {
      window.open(shareLinks[platform], "_blank", "noopener,noreferrer,width=600,height=400");
    };
    $[3] = t5;
    $[4] = t6;
    $[5] = t7;
    $[6] = t8;
    $[7] = t9;
    $[8] = t10;
  } else {
    t10 = $[8];
  }
  const handleShare = t10;
  let t11;
  if ($[9] !== fullUrl) {
    t11 = async () => {
      ;
      try {
        await navigator.clipboard.writeText(fullUrl);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      } catch (t12) {
        const err = t12;
        console.error("Failed to copy:", err);
      }
    };
    $[9] = fullUrl;
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  const handleCopyLink = t11;
  const t12 = `gap-2 backdrop-blur-md select-none ${className}`;
  let t13;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Share2 className="h-4 w-4" />;
    $[11] = t13;
  } else {
    t13 = $[11];
  }
  let t14;
  if ($[12] !== t) {
    t14 = t("share");
    $[12] = t;
    $[13] = t14;
  } else {
    t14 = $[13];
  }
  let t15;
  if ($[14] !== t14) {
    t15 = <span className="hidden sm:inline">{t14}</span>;
    $[14] = t14;
    $[15] = t15;
  } else {
    t15 = $[15];
  }
  let t16;
  if ($[16] !== size || $[17] !== t12 || $[18] !== t15 || $[19] !== variant) {
    t16 = <DropdownMenuTrigger asChild={true}><Button variant={variant} size={size} className={t12}>{t13}{t15}</Button></DropdownMenuTrigger>;
    $[16] = size;
    $[17] = t12;
    $[18] = t15;
    $[19] = variant;
    $[20] = t16;
  } else {
    t16 = $[20];
  }
  let t17;
  if ($[21] !== handleShare) {
    t17 = () => handleShare("facebook");
    $[21] = handleShare;
    $[22] = t17;
  } else {
    t17 = $[22];
  }
  let t18;
  let t19;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" /></svg>;
    t19 = <span>Facebook</span>;
    $[23] = t18;
    $[24] = t19;
  } else {
    t18 = $[23];
    t19 = $[24];
  }
  let t20;
  if ($[25] !== t17) {
    t20 = <DropdownMenuItem onClick={t17} className="cursor-pointer gap-2">{t18}{t19}</DropdownMenuItem>;
    $[25] = t17;
    $[26] = t20;
  } else {
    t20 = $[26];
  }
  let t21;
  if ($[27] !== handleShare) {
    t21 = () => handleShare("x");
    $[27] = handleShare;
    $[28] = t21;
  } else {
    t21 = $[28];
  }
  let t22;
  let t23;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 24 24"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" /></svg>;
    t23 = <span>X</span>;
    $[29] = t22;
    $[30] = t23;
  } else {
    t22 = $[29];
    t23 = $[30];
  }
  let t24;
  if ($[31] !== t21) {
    t24 = <DropdownMenuItem onClick={t21} className="cursor-pointer gap-2">{t22}{t23}</DropdownMenuItem>;
    $[31] = t21;
    $[32] = t24;
  } else {
    t24 = $[32];
  }
  let t25;
  if ($[33] !== handleShare) {
    t25 = () => handleShare("linkedin");
    $[33] = handleShare;
    $[34] = t25;
  } else {
    t25 = $[34];
  }
  let t26;
  let t27;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 24 24"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" /></svg>;
    t27 = <span>LinkedIn</span>;
    $[35] = t26;
    $[36] = t27;
  } else {
    t26 = $[35];
    t27 = $[36];
  }
  let t28;
  if ($[37] !== t25) {
    t28 = <DropdownMenuItem onClick={t25} className="cursor-pointer gap-2">{t26}{t27}</DropdownMenuItem>;
    $[37] = t25;
    $[38] = t28;
  } else {
    t28 = $[38];
  }
  let t29;
  if ($[39] !== handleShare) {
    t29 = () => handleShare("whatsapp");
    $[39] = handleShare;
    $[40] = t29;
  } else {
    t29 = $[40];
  }
  let t30;
  let t31;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 24 24"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" /></svg>;
    t31 = <span>WhatsApp</span>;
    $[41] = t30;
    $[42] = t31;
  } else {
    t30 = $[41];
    t31 = $[42];
  }
  let t32;
  if ($[43] !== t29) {
    t32 = <DropdownMenuItem onClick={t29} className="cursor-pointer gap-2">{t30}{t31}</DropdownMenuItem>;
    $[43] = t29;
    $[44] = t32;
  } else {
    t32 = $[44];
  }
  let t33;
  if ($[45] !== handleShare) {
    t33 = () => handleShare("telegram");
    $[45] = handleShare;
    $[46] = t33;
  } else {
    t33 = $[46];
  }
  let t34;
  let t35;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 24 24"><path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" /></svg>;
    t35 = <span>Telegram</span>;
    $[47] = t34;
    $[48] = t35;
  } else {
    t34 = $[47];
    t35 = $[48];
  }
  let t36;
  if ($[49] !== t33) {
    t36 = <DropdownMenuItem onClick={t33} className="cursor-pointer gap-2">{t34}{t35}</DropdownMenuItem>;
    $[49] = t33;
    $[50] = t36;
  } else {
    t36 = $[50];
  }
  let t37;
  if ($[51] !== copied) {
    t37 = copied ? <Check className="h-4 w-4 text-green-500" /> : <LinkIcon className="h-4 w-4" />;
    $[51] = copied;
    $[52] = t37;
  } else {
    t37 = $[52];
  }
  let t38;
  if ($[53] !== copied || $[54] !== t) {
    t38 = copied ? t("copied") : t("copy_link");
    $[53] = copied;
    $[54] = t;
    $[55] = t38;
  } else {
    t38 = $[55];
  }
  let t39;
  if ($[56] !== t38) {
    t39 = <span>{t38}</span>;
    $[56] = t38;
    $[57] = t39;
  } else {
    t39 = $[57];
  }
  let t40;
  if ($[58] !== handleCopyLink || $[59] !== t37 || $[60] !== t39) {
    t40 = <DropdownMenuItem onClick={handleCopyLink} className="cursor-pointer gap-2">{t37}{t39}</DropdownMenuItem>;
    $[58] = handleCopyLink;
    $[59] = t37;
    $[60] = t39;
    $[61] = t40;
  } else {
    t40 = $[61];
  }
  let t41;
  if ($[62] !== t20 || $[63] !== t24 || $[64] !== t28 || $[65] !== t32 || $[66] !== t36 || $[67] !== t40) {
    t41 = <DropdownMenuContent align="end" className="w-48 select-none">{t20}{t24}{t28}{t32}{t36}{t40}</DropdownMenuContent>;
    $[62] = t20;
    $[63] = t24;
    $[64] = t28;
    $[65] = t32;
    $[66] = t36;
    $[67] = t40;
    $[68] = t41;
  } else {
    t41 = $[68];
  }
  let t42;
  if ($[69] !== t16 || $[70] !== t41) {
    t42 = <DropdownMenu>{t16}{t41}</DropdownMenu>;
    $[69] = t16;
    $[70] = t41;
    $[71] = t42;
  } else {
    t42 = $[71];
  }
  return t42;
};
export default ShareButton;